import { Button } from '@mantine/core';
import { IconFileTypePdf } from '@tabler/icons-react';

import { Id } from '@feature/utils';

interface EvaluationReportButtonProps {
  evaluationId: Id;
  authorId: Id;
}

const onDownload = (evaluationId: Id, authorId: Id) => {
  window.open(`/api/author-evaluation/${evaluationId}/author/${authorId}/data/pdf`);
};

export function EvaluationReportButton({ evaluationId, authorId }: EvaluationReportButtonProps) {
  return (
    <Button
      size="xs"
      leftSection={<IconFileTypePdf size="24px" />}
      onClick={() => onDownload(evaluationId, authorId)}
    >
      Descarcă fișă de evaluare - FARĂ semnătură
    </Button>
  );
}
